<template>
  <v-dialog
    v-model="dialogo"
    width="500"
    @click:outside="clickFuera"
    @keydown.esc="accionDialogo()"
  >
    <v-card>
      <v-card-title
        class="headline orange lighten-2"
        transition="dialog-top-transition"
        >{{ tituloDialogo }}</v-card-title
      >
      <v-card-text class="mt-2">{{ comentarioDialogo }}</v-card-text>
      <v-card-actions>
        <v-btn
          color="black"
          text
          v-for="(botones, indice) in botonesDialogo"
          :key="indice"
          @keypress.enter="clickFuera"
          @click="accionDialogo(indice)"
          >{{ botones }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogo: false,
      tituloDialogo: "",
      comentarioDialogo: "",
      botonesDialogo: [],
    };
  },
  methods: {
    activarDialogo(titulo, comentario, botones) {
      return new Promise((resolve, reject) => {
        this.tituloDialogo = titulo;
        this.comentarioDialogo = comentario;
        this.botonesDialogo = botones;
        this.dialogo = true;
        this.promesaResolve = resolve;
        this.promesaReject = reject;
      });
    },
    accionDialogo(indiceBoton) {
      this.promesaResolve(indiceBoton);
      this.dialogo = false;
    },
    clickFuera() {
      this.promesaReject();
    },
  },
};
</script>

<style>
</style>
